import { isMockMode, postBlast, simulateDelay } from "../../api";

interface DeleteNodeLibraryRequest {
	id: string;
	isDeleted?: boolean;
}

export const deleteNodeLibrary = ({
	id,
	isDeleted = true,
}: DeleteNodeLibraryRequest) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`nodelibrary/delete`, {
		id,
		isDeleted,
	});
};
